import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import { Toaster } from "sonner";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import OAuthBridge from "@/pages/OAuthBridge";
import DashboardHome from "@/pages/DashboardHome";
import MeetingsLibrary from "@/pages/MeetingsLibrary";
import MeetingDetail from "@/pages/MeetingDetail";
import Settings from "@/pages/Settings";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id BEFORE rendering routes (avoids race condition with /auth/me).
  // Exception: the OAuth bridge MUST handle its own hash to forward to the custom domain.
  if (location.hash?.includes("session_id=") && location.pathname !== "/auth/oauth-bridge") {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/auth/oauth-bridge" element={<OAuthBridge />} />
      <Route path="/app/home" element={<ProtectedRoute><DashboardHome /></ProtectedRoute>} />
      <Route path="/app/meetings" element={<ProtectedRoute><MeetingsLibrary /></ProtectedRoute>} />
      <Route path="/app/meetings/:id" element={<ProtectedRoute><MeetingDetail /></ProtectedRoute>} />
      <Route path="/app/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/app/calendar" element={<Navigate to="/app/settings?tab=calendar" replace />} />
      <Route path="/app" element={<Navigate to="/app/home" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
